import { GET_SECTOR_BUYERS, GET_SECTOR_BUYERS_ERROR, GET_SECTOR_BUYERS_SUCCESS } from './SectorBuyersSection.actions'

const sectorBuyersSectionState = {
  csv: [],
  data: [],
  error: null,
  loading: false,
  page: 1,
  pages: 1,
  records: 1
}

/**
 * The sector buyers section's reducer.
 */
const sectorBuyersSectionReducer = (state = sectorBuyersSectionState, { payload, type }) => {
  switch (type) {
    case GET_SECTOR_BUYERS: {
      return { ...state, loading: true }
    }
    case GET_SECTOR_BUYERS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_SECTOR_BUYERS_SUCCESS: {
      return { ...state, loading: false, ...payload }
    }
    default: {
      return state
    }
  }
}

export default sectorBuyersSectionReducer
